import {
  ModalManager,
  useModal,
} from "@circle-react/components/Layout/ModalManagerProvider";

import { SpotlightSearchV4 } from "@/react/components/search/SpotlightSearchV4";

const SpotlightSearchComponent = () => {
  const drawer = useModal();

  return <SpotlightSearchV4 isOpen={drawer.visible} onClose={drawer.hide} />;
};

const SpotlightSearch = ModalManager.create(() => <SpotlightSearchComponent />);

export const useSpotlightSearch = () => useModal(SpotlightSearch);
